import React from "react";

const ShiftRotation = () => {
    return <div>ShiftRotation</div>;
}
export default ShiftRotation;